import Vue from 'vue'
import VueX from 'vuex'
import routes from './routes'
import store from './store'
import mixins from './mixins'

// plugins
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// plugins css
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/app.css'
import './assets/responsive.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

//구글 캡챠 추가
import { VueReCaptcha } from 'vue-recaptcha-v3'


import App from './App.vue'
Vue.config.productionTip = false

Vue.use(VueX)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//구글 캡챠 추가
/*
Vue.use(VueReCaptcha, { 
  siteKey: '6LezVhAsAAAAAGEjC48m7QheIOiaMp8HTAEso_MS',
  loaderOptions: {
    autoHideBadge: false
  }
})*/

const loadRecaptcha = () => {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      console.warn('reCAPTCHA 로드 실패 (사내망으로 판단)');
      resolve(false);
    }, 1000);

    Vue.use(VueReCaptcha, { 
      siteKey: '6LferBgsAAAAAHHMHv40u6IPOjwMGzznruw64QWO',
      loaderOptions: {
        autoHideBadge: false
      }
    });

    // 로드 성공 시
    clearTimeout(timeout);
    resolve(true);
  });
};

loadRecaptcha();

import VueSignaturePad from 'vue-signature-pad'
Vue.use(VueSignaturePad)

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

if (!document.startViewTransition) document.startViewTransition = f => f();
Vue.mixin(mixins)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
